// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".simple-flight-form-content {\n  padding: 10px;\n  display: grid;\n  height: calc(100vh - 64px);\n}\n.simple-flight-form {\n  grid-column-start: content-start;\n  grid-column-end: content-end;\n}\n.simple-flight-offer-saved-offers-header {\n  padding-top: 50px;\n}\n", ""]);
// Exports
module.exports = exports;
